module.exports = __webpack_public_path__ + "img/gd-granazi1.6d2efbd9.png";